import React from 'react';
import {compareProps} from '@netx/core-next/utils/react';
import {Form} from './Form';
import type {FormAction, FormType, FormValues} from './hooks/useForm';

type LegacyFormRef = React.ForwardedRef<HTMLFormElement>;

export interface LegacyFormProps<
	TValues extends FormValues = FormValues,
	TAction extends FormAction = FormAction,
> extends Omit<
		React.DetailedHTMLProps<
			React.HTMLAttributes<HTMLFormElement>,
			HTMLFormElement
		>,
		'noValidate' | 'onSubmit'
	> {
	form?: FormType<TValues, TAction>;
	onSubmit?: (
		values: FormType<TValues, TAction>['values'],
		changes?: FormType<TValues, TAction>['changes'],
		actions?: FormType<TValues, TAction>['actions'],
	) => Promise<any> | React.FormEventHandler<HTMLFormElement>;
}

/**
 * A "helpful" wrapper <form> that deals with some boiler plate settings
 * @deprecated
 */
const LegacyFormInner = <TValues extends FormValues = FormValues>(
	{
		children,

		form,
		onSubmit,
		...props
	}: LegacyFormProps<TValues>,
	ref?: LegacyFormRef,
) => {
	const sendProps: any = {};
	if (form && form.options?.onSubmit) {
		sendProps.onSubmit = form.handleSubmit(form.options?.onSubmit);
	} else if (form && onSubmit) {
		// TODO: fix this stuff
		sendProps.onSubmit = form.handleSubmit(onSubmit as any);
	} else {
		sendProps.onSubmit = onSubmit;
	}
	return (
		<Form {...props} {...sendProps}>
			{children}
		</Form>
	);
};

export const LegacyFormPrimitive = React.forwardRef(LegacyFormInner) as <
	TValues extends FormValues = FormValues,
>(
	props: LegacyFormProps<TValues>,
	ref?: LegacyFormRef,
) => JSX.Element;

export const LegacyForm = React.memo(LegacyFormPrimitive, compareProps([])) as <
	TValues extends FormValues = FormValues,
>(
	props: LegacyFormProps<TValues>,
	ref?: LegacyFormRef,
) => JSX.Element;

export default LegacyForm;
